/*
To enable highlight feature on a page:
  - In the HTML, add:
      ------------ before start button ------------
	  <div class="interface-timer-container-yash flex-yash">
		  <img class="interface-bottom-button-yash interface-highlight-button-yash flex-yash" src="<%= vite_asset_path('images/interface/yellow-highlight') %>" data-color="yellow" />
		  <img class="interface-bottom-button-yash interface-highlight-button-yash flex-yash" src="<%= vite_asset_path('images/interface/pink-highlight') %>" data-color="pink" />
		  <img class="interface-bottom-button-yash interface-highlight-button-yash flex-yash" src="<%= vite_asset_path('images/interface/orange-highlight') %>" data-color="orange" />
		  <img class="interface-bottom-button-yash interface-eraser-button-yash flex-yash" src="<%= vite_asset_path('images/interface/eraser') %>" data-color="orange" />
		.......

	  ------------ containers ------------
	  <div id="interface-setup-container-<%= question.question_number %>-yash" class="interface-setup-container-yash">
		  <div class="interface-cover-yash" style="z-index: 1; padding: 2%; pointer-events: auto">
		    <div id="<%= @preptest_number %>-<%= question.section_number %>-<%= question.question_number %>-P-highlight-yash" class="interface-cover-yash interface-highlight-container-yash" style="pointer-events: auto"> </div>
		  </div>
		  ......
	  </div>
	  ......
	  <div class="interface-questions-yash">
	    <div class="interface-cover-yash" style="z-index: 1; padding: 2%; pointer-events: auto">
	      <div id="<%= @preptest_number %>-<%= question.section_number %>-<%= question.question_number %>-Q-highlight-yash" class="interface-cover-yash interface-highlight-container-yash" style="pointer-events: auto"> </div>
	      </div>
	    ......
	  </div>
*/

var highlighter = {
		highlighterClicked: false,
		eraserClicked: false,
		mousePressed: false,
		initialX: null,
		initialY: null,
		minSwipeDistance: 20,
		swipeDirection: null,
		initialWord: null, // becomes an object literal on use: { group: _, row: _, word: _ }
		currentWord: null, // becomes an object literal on use: { row: _, word: _ }
		previousWord: null, // becomes an object literal on use: { row: _, word: _ }
		color: null,
		allowsPointerEvents: false,
	};

function highlightFeature(imageData) {
	console.log("In the highlighterFeature function")
	$(".interface-highlight-container-yash").data("loaded", "false");
	// add highlight divs to the first one
	var firstSetupImage = $("#interface-setup-container-1-yash").find(".interface-highlight-container-yash").get(0).id.replace("-highlight-yash", "");
	loadHighlightForOneImage(firstSetupImage, imageData);
	var firstQuestionsImage = $("#interface-questions-container-holder-1-yash").find(".interface-highlight-container-yash").get(0).id.replace("-highlight-yash", "");
	loadHighlightForOneImage(firstQuestionsImage, imageData);

	// Note: We don't set up jQuery click handlers here anymore because
	// the highlight buttons use Stimulus controllers (highlight-button)
	// which call clickHighlightButton directly

	if (
		"onpointerover" in document.documentElement &&
		"onpointerdown" in document.documentElement &&
		"onpointermove" in document.documentElement &&
		"onpointerup" in document.documentElement
	) {
		highlighter.allowsPointerEvents = true;
	}
}

function loadHighlightForOneImage(image, imageData) {
	if ($("#"+image+"-highlight-yash").data("loaded") === "true")
		return
	console.log("b4 check: ", imageData)
	if (imageData === undefined || imageData === null) {
		return
	}

	var nWidth = document.getElementById(image + "-alt").naturalWidth;
	var nHeight = document.getElementById(image + "-alt").naturalHeight;
	console.log("imageData[image]", imageData[image], image)
	if (imageData[image] === undefined) {
		$("#"+image+"-highlight-yash").data("loaded", "true");
		return;
	}

	console.log(image, imageData);

	for (var group = 0; group < imageData[image].length; group++) {
		for (var row = 0; row < imageData[image][group].length; row++) {
			var top = imageData[image][group][row]["top"];
			var bottom = imageData[image][group][row]["bottom"];
			var lastRight = -1;
			for (
				var word = 0;
				word < imageData[image][group][row]["words"].length;
				word++
			) {
				var left = imageData[image][group][row]["words"][word]["left"];
				var right = imageData[image][group][row]["words"][word]["right"];

				// create gap to the left, except for the first word
				if (lastRight != -1) {
					addHighlightDiv(
						group,
						row,
						word - 0.5,
						lastRight,
						left,
						top,
						bottom,
						nWidth,
						nHeight,
						image
					);
				}

				// create div
				addHighlightDiv(
					group,
					row,
					word,
					left,
					right,
					top,
					bottom,
					nWidth,
					nHeight,
					image
				);

				lastRight = right;
			}
		}
	}

	if ($("#"+image+"-highlight-yash").children().length > 0)
		$("#"+image+"-highlight-yash").data("loaded", "true");

	detachHighlightEvents();
	if (highlighter.highlighterClicked || highlighter.eraserClicked)
		attachHighlightEvents();
}

function detachHighlightEvents() {
		// if we accidentally add an event listener twice to an element,
		// JS will call that event twice every time the event is triggered.
		// so we must always turn off the event listeners before enabling them
		if (highlighter.allowsPointerEvents) {
			$(".interface-word-yash").off("pointerdown pointerover");
			$(".interface-gap-yash").off("pointerdown pointerover");
			$(".interface-highlight-container-yash").off("pointerdown pointermove");
			$(".interface-yash").off("pointerup");
		} else {
			$(".interface-word-yash").off("mousedown mouseover");
			$(".interface-gap-yash").off("mousedown mouseover");
			$(".interface-highlight-container-yash").off("mousedown mousemove");
			$(".interface-yash").off("mouseup");
		}
	}

	function attachHighlightEvents() {
		console.log('[highlight] attachHighlightEvents called, allowsPointerEvents:', highlighter.allowsPointerEvents);
		const wordCount = document.querySelectorAll(".interface-word-yash").length;
		const gapCount = document.querySelectorAll(".interface-gap-yash").length;
		const containerCount = document.querySelectorAll(".interface-highlight-container-yash").length;
		console.log('[highlight] Found', wordCount, 'words,', gapCount, 'gaps,', containerCount, 'containers');

		if (highlighter.allowsPointerEvents) {
			[...document.querySelectorAll(".interface-word-yash")].forEach(function(
				item
			) {
				item.addEventListener("pointerdown", highlightTargetMouseDown);
				item.addEventListener("pointerover", highlightMouseOver);
			});
			[...document.querySelectorAll(".interface-gap-yash")].forEach(function(
				item
			) {
				item.addEventListener("pointerdown", highlightTargetMouseDown);
				item.addEventListener("pointerover", highlightMouseOver);
			});
			[
				...document.querySelectorAll(".interface-highlight-container-yash")
			].forEach(function(item) {
				item.addEventListener("pointerdown", highlightContainerMouseDown);
				item.addEventListener("pointermove", highlightMouseMove);
			});
			[...document.querySelectorAll(".interface-yash")].forEach(function(
				item
			) {
				item.addEventListener("pointerup", highlightMouseUp);
			});
			console.log('[highlight] Attached pointer events to', wordCount + gapCount, 'elements');
		} else {
			const wordElements = $(".interface-word-yash");
			const gapElements = $(".interface-gap-yash");
			const containerElements = $(".interface-highlight-container-yash");
			const yashElements = $(".interface-yash");

			wordElements.mousedown(highlightTargetMouseDown).mouseover(highlightMouseOver);
			gapElements.mousedown(highlightTargetMouseDown).mouseover(highlightMouseOver);
			containerElements.mousedown(highlightContainerMouseDown).mousemove(highlightMouseMove);
			yashElements.mouseup(highlightMouseUp);

			console.log('[highlight] Attached mouse events to', wordElements.length + gapElements.length, 'elements');
		}
	}

function addHighlightDiv(
		group,
		row,
		word,
		left,
		right,
		top,
		bottom,
		nWidth,
		nHeight,
		image
	) {
	var iDiv = document.createElement("div");
	document.getElementById(image + "-highlight-yash").appendChild(iDiv);

	var containerWidth;
	var containerHeight;
	var container = $("#"+image+"-highlight-yash");
	// var questionSide = false;
	// if (
	// 	$(iDiv)
	// 		.parent()
	// 		.parent()
	// 		.parent()
	// 		.hasClass("interface-questions-yash")
	// ) {
	// 	questionSide = true; // right - hand side image
	// 	container = $(".interface-questions-yash")
	// 		.first()
	// 		.find(".interface-highlight-container-yash");
	// } else
	// 	container = $("#interface-setup-container-1-yash").find(
	// 		".interface-highlight-container-yash"
	// 	);

	containerWidth = container.width();
	containerHeight = container.height();
	var imageHeight = (nHeight / nWidth) * containerWidth;
	// if (questionSide && imageHeight > containerHeight * 1.02)
		// take into account padding
		// containerWidth -= 7.89;

	var widthPercent = (100 * (right - left)) / nWidth;
	var naturalRowHeight = bottom - top;
	var heightPercent =
		100 * (containerWidth / containerHeight) * (naturalRowHeight / nWidth);
	// widthPercent--;  //to account for padding
	// heightPercent--; //to account for padding

	left = String((100 * left) / nWidth) + "%";
	top =
		String(100 * (containerWidth / containerHeight) * (top / nWidth)) + "%";

	if (word % 1 === 0) {
		iDiv.className = "interface-word-yash";
	} else {
		iDiv.className = "interface-gap-yash";
	}
	iDiv.setAttribute("data-group", group);
	iDiv.setAttribute("data-row", row);
	iDiv.setAttribute("data-word", word);
	$(iDiv).css({
		width: String(widthPercent) + "%",
		height: String(heightPercent) + "%",
		left: left,
		top: top
	});
}

function clickHighlightButton() {
	console.log('[highlight] clickHighlightButton called');
	if ($(this).hasClass("interface-highlight-button-border-yash")) {
		// Button was already selected, deselect it
		highlighter.eraserClicked = false;
		highlighter.highlighterClicked = false;
		highlighter.color = null;
		$(this).removeClass("interface-highlight-button-border-yash");
		console.log('[highlight] Button deselected');
	} else {
		// Button was not selected, select it
		$(this).addClass("interface-highlight-button-border-yash");
		var clicked = this;
		$(".interface-highlight-button-yash")
			.filter(function() {
				return this != clicked;
			})
			.removeClass("interface-highlight-button-border-yash");
		// enable highlighter or eraser
		if ($(this).hasClass("interface-eraser-button-yash")) {
			highlighter.eraserClicked = true;
			highlighter.highlighterClicked = false;
			highlighter.color = null;
			console.log('[highlight] Eraser activated');
		} else {
			highlighter.eraserClicked = false;
			highlighter.highlighterClicked = true;
			highlighter.color = $(this).data("color");
			console.log('[highlight] Highlighter activated, color:', highlighter.color);
		}
	}

	detachHighlightEvents();
	if (highlighter.highlighterClicked || highlighter.eraserClicked) {
		console.log('[highlight] About to attach events, highlighterClicked:', highlighter.highlighterClicked, 'eraserClicked:', highlighter.eraserClicked);
		attachHighlightEvents();
	} else {
		console.log('[highlight] Not attaching events - no button active');
	}
}

function highlightTargetMouseDown(event) {
	highlighter.initialWord = highlighter.previousWord = highlighter.currentWord = this;
	this.releasePointerCapture(event.pointerId);
}

function highlightContainerMouseDown(event) {
	// for container
	if (
		highlighter.highlighterClicked === true ||
		highlighter.eraserClicked === true
	) {
		highlighter.mousePressed = true;
		highlighter.initialX = event.pageX;
		highlighter.initialY = event.pageY;
	}
}

function highlightMouseUp() {
	// for container
	if (highlighter.mousePressed === false) return; // if they did mouseup anywhere else on the screen
	highlighter.mousePressed = false;

	$(".interface-setup-container-yash").removeClass("touch-action-none");
	$(".interface-questions-yash").removeClass("touch-action-none");

	if (highlighter.highlighterClicked) {
		$(".interface-temp-yellow-yash")
			.addClass("interface-perm-yellow-yash")
			.removeClass(
				"interface-temp-yellow-yash interface-perm-pink-yash interface-perm-orange-yash"
			);
		$(".interface-temp-pink-yash")
			.addClass("interface-perm-pink-yash")
			.removeClass(
				"interface-temp-pink-yash interface-perm-yellow-yash interface-perm-orange-yash"
			);
		$(".interface-temp-orange-yash")
			.addClass("interface-perm-orange-yash")
			.removeClass(
				"interface-temp-orange-yash interface-perm-yellow-yash interface-perm-pink-yash"
			);

		// Check gaps on the edges
		// A WORK IN PROGRESS
		var first = $(highlighter.initialWord);
		var last = $(highlighter.currentWord);
		if (
			!isBefore(
				$(highlighter.initialWord).data("row"),
				$(highlighter.initialWord).data("word"),
				$(highlighter.currentWord).data("row"),
				$(highlighter.currentWord).data("word")
			)
		) {
			first = $(highlighter.currentWord);
			last = $(highlighter.initialWord);
		}
		if (first !== last) {
			//previous
			if (first.hasClass("interface-word-yash")) {
				// <-- CAUSING PROBLEMS
				var prevGap = first.prev();
				if (prevGap.length > 0) {
					var wordBeforePrevGap = prevGap.prev();
					if (wordBeforePrevGap.length > 0) {
						addColorBetweenIndividualHighlights(
							wordBeforePrevGap,
							prevGap,
							first
						);
					}
				}
			} else {
				// if the initial word is a gap, check its left and right to decide what color it will be
				addColorBetweenIndividualHighlights(
					first.prev(),
					first,
					first.next()
				);
			}

			// next gap after individual highlight
			if (last.hasClass("interface-word-yash")) {
				var nextGap = last.next();
				if (nextGap.length > 0) {
					var wordAfterNextGap = nextGap.next();
					if (wordAfterNextGap.length > 0) {
						addColorBetweenIndividualHighlights(
							last,
							nextGap,
							wordAfterNextGap
						);
					}
				}
			} else {
				// if the last word is a gap
				addColorBetweenIndividualHighlights(last.prev(), last, last.next());
			}
		}
	} else if (highlighter.eraserClicked) {
		$(".interface-should-erase-yash").removeClass(
			"interface-perm-pink-yash interface-perm-yellow-yash interface-perm-orange-yash interface-should-erase-yash"
		);
	}

	highlighter.initialX = highlighter.initialY = 0;
	highlighter.initialWord = highlighter.currentWord = highlighter.previousWord = highlighter.swipeDirection = null;
}

function addColorBetweenIndividualHighlights(prev, gap, next) {
	if (prev.length < 1 || gap.length < 1 || next.length < 1) {
		return;
	}
	if (
		prev.hasClass("interface-gap-yash") ||
		gap.hasClass("interface-word-yash") ||
		next.hasClass("interface-gap-yash")
	) {
		return;
	}
	if (
		prev.hasClass("interface-perm-yellow-yash") &&
		next.hasClass("interface-perm-yellow-yash")
	) {
		gap.addClass("interface-perm-yellow-yash");
	} else if (
		prev.hasClass("interface-perm-pink-yash") &&
		next.hasClass("interface-perm-pink-yash")
	) {
		gap.addClass("interface-perm-pink-yash");
	} else if (
		prev.hasClass("interface-perm-orange-yash") &&
		next.hasClass("interface-perm-orange-yash")
	) {
		gap.addClass("interface-perm-orange-yash");
	} else {
		gap.removeClass(
			"interface-perm-yellow-yash interface-perm-pink-yash interface-perm-orange-yash"
		);
	}
}

/**
 *
 *
 */
function highlightMouseMove(event) {
	// for container
	if (
		highlighter.mousePressed !== true ||
		swipeDirection(event.pageX, event.pageY) === "vertical"
	) {
		return;
	}

	if (getDistance(event.pageX, event.pageY) < highlighter.minSwipeDistance) {
		// CLEAR HIGHLIGHT
		if (highlighter.highlighterClicked) {
			$(".interface-temp-" + highlighter.color + "-yash").removeClass(
				"interface-temp-" + highlighter.color + "-yash"
			);
		} else if (highlighter.eraserClicked) {
			$(".interface-should-erase-yash").removeClass(
				"interface-should-erase-yash"
			);
		}
	} else {
		if (highlighter.highlighterClicked) redrawHighlight();
		else if (highlighter.eraserClicked) redrawErase();
	}
	//if min distance is less than it should be, cle ar the stuff
	// check if the first word is identical to the current word
	// if the first word is the current word AND we exceed minimum distance, light it up
}

function highlightMouseOver(e) {
	if (highlighter.mousePressed !== true) {
		return;
	}
	if (swipeDirection(event.pageX, event.pageY) === "vertical") {
		return;
	}


	// If user did NOT mouse down on an actual word or gap, then set this word as the initial
	if (highlighter.initialWord === null) {
		highlighter.initialWord = highlighter.previousWord = highlighter.currentWord = this;
	} else if (
		$(this).data("group") !== $(highlighter.initialWord).data("group")
	) {
		return;
	} else {
		highlighter.previousWord = highlighter.currentWord;
		highlighter.currentWord = this;
	}

	if (highlighter.highlighterClicked) {
		redrawHighlight();
	} else if (highlighter.eraserClicked) {
		redrawErase();
	}
}

function redrawHighlight() {
	var target = $(highlighter.currentWord); // the word we last moused over
	var initialIsGap = 0;
	// If the initial word is a gap, act as if the initial word is the word to the right of the gap
	if ($(highlighter.initialWord).data("word") % 1 === 0.5) {
		initialIsGap = 0.5;
	}

	if (
		isBefore(
			$(highlighter.initialWord).data("row"),
			$(highlighter.initialWord).data("word"),
			$(highlighter.currentWord).data("row"),
			$(highlighter.currentWord).data("word")
		)
	) {
		if (target.hasClass("interface-gap-yash")) {
			// If the final word is a gap, only highlight until the word to the left of the gap
			target = target.prev(); // this will always work because the first word of any group is never a gap
		}

		// target.length > 0 checks if target points to an element on the page
		while (
			target.length > 0 &&
			target.data("row") >= $(highlighter.initialWord).data("row")
		) {
			target.addClass("interface-temp-" + highlighter.color + "-yash");
			if (
				target.data("row") === $(highlighter.initialWord).data("row") &&
				target.data("word") ===
					$(highlighter.initialWord).data("word") + initialIsGap
			)
				break;
			target = target.prev();
		}

		// Clear the words that come before the current word
		target = $(highlighter.initialWord);
		if (target.hasClass("interface-word-yash")) target = target.prev();
		while (
			target.length > 0 &&
			target.data("group") === $(highlighter.initialWord).data("group")
		) {
			target.removeClass("interface-temp-" + highlighter.color + "-yash");
			target = target.prev();
		}

		// Clear the words that come after the current word
		target = $(highlighter.currentWord);
		if (target.hasClass("interface-word-yash")) target = target.next();
		while (
			target.length > 0 &&
			target.data("group") === $(highlighter.initialWord).data("group")
		) {
			target.removeClass("interface-temp-" + highlighter.color + "-yash");
			target = target.next();
		}
	} else {
		if (target === $(highlighter.initialWord)) {
			$(".interface-temp-" + highlighter.color + "-yash").removeClass(
				"interface-temp-" + highlighter.color + "-yash"
			);
			target.addClass("interface-temp-" + highlighter.color + "-yash");
		}
		if (target.hasClass("interface-gap-yash")) {
			// If the final word is a gap, only highlight until the word to the right of the gap
			target = target.next();
		}

		// target.length > 0 checks if target points to an element on the page
		while (
			target.length > 0 &&
			target.data("row") <= $(highlighter.initialWord).data("row")
		) {
			target.addClass("interface-temp-" + highlighter.color + "-yash");
			if (
				target.data("row") === $(highlighter.initialWord).data("row") &&
				target.data("word") ===
					$(highlighter.initialWord).data("word") - initialIsGap
			)
				break;
			target = target.next();
		}

		// Clear the words that come before the current word
		target = $(highlighter.currentWord);
		if (target.hasClass("interface-word-yash")) target = target.prev();
		while (
			target.length > 0 &&
			target.data("group") === $(highlighter.initialWord).data("group")
		) {
			target.removeClass("interface-temp-" + highlighter.color + "-yash");
			target = target.prev();
		}

		// Clear the words that come after the current word
		target = $(highlighter.initialWord);
		if (target.hasClass("interface-word-yash")) target = target.next();
		while (
			target.length > 0 &&
			target.data("group") === $(highlighter.initialWord).data("group")
		) {
			target.removeClass("interface-temp-" + highlighter.color + "-yash");
			target = target.next();
		}
	}
}

function redrawErase() {
	var first = $(highlighter.initialWord);
	var last = $(highlighter.currentWord);
	if (
		!isBefore(
			$(highlighter.initialWord).data("row"),
			$(highlighter.initialWord).data("word"),
			$(highlighter.currentWord).data("row"),
			$(highlighter.currentWord).data("word")
		)
	) {
		first = $(highlighter.currentWord);
		last = $(highlighter.initialWord);
	}

	$(".interface-should-erase-yash").removeClass(
		"interface-should-erase-yash"
	);

	if (first !== last) {
		var iterator = first;
		while (iterator[0] !== last[0]) {
			// [0] compares the actual JS object rather than the jQuery wrapper
			iterator.addClass("interface-should-erase-yash");
			iterator = iterator.next();
		}

		eraseChunk(first);
		eraseChunk(last);
	} else {
		eraseChunk(first);
	}
}

function eraseChunk(element) {
	var color = null;
	if (element.length > 0) {
		if (element.hasClass("interface-perm-pink-yash")) color = "pink";
		else if (element.hasClass("interface-perm-yellow-yash")) color = "yellow";
		else if (element.hasClass("interface-perm-orange-yash")) color = "orange";
	}
	if (color !== null) {
		element.addClass("interface-should-erase-yash");
		var iterator = element.prev();
		while (
			iterator.length > 0 &&
			iterator.hasClass("interface-perm-" + color + "-yash")
		) {
			iterator.addClass("interface-should-erase-yash");
			iterator = iterator.prev();
		}

		iterator = element.next();
		while (
			iterator.length > 0 &&
			iterator.hasClass("interface-perm-" + color + "-yash")
		) {
			iterator.addClass("interface-should-erase-yash");
			iterator = iterator.next();
		}
	}
}

/**
 * The swipe direction determines whether or not we should highlight
 */
function swipeDirection(currentX, currentY) {
	// If we haven't set a swipe direction yet and we have exceeded the minimum distance
	if (
		highlighter.swipeDirection === null &&
		getDistance(currentX, currentY) > highlighter.minSwipeDistance
	) {
		// If we moved more horizontally than vertically
		if (
			Math.abs(currentY - highlighter.initialY) >
			Math.abs(currentX - highlighter.initialX)
		) {
			highlighter.swipeDirection = "vertical";
		} else {
			highlighter.swipeDirection = "horizontal";
			$(".interface-setup-container-yash").addClass("touch-action-none");
			$(".interface-questions-yash").addClass("touch-action-none");
		}
	}


	// Always return the swipe direction, even if we did not have to set it
	return highlighter.swipeDirection;
}

/**
 * Returns the distance between two points
 */
function getDistance(currentX, currentY) {
	if (
		currentX === null ||
		highlighter.initialX === null ||
		currentY === null ||
		highlighter.initialY === null
	) {
		return -1;
	}
	return Math.sqrt(
		Math.pow(currentX - highlighter.initialX, 2) +
			Math.pow(currentY - highlighter.initialY, 2)
	);
}

/*
 * Returns if word x is before word y.
 * For example, the fifth word in the third row comes before
 * the fourth word in the sixth row (so isBefore would output true).
 * If the words are the same, isBefore outputs false
 */
function isBefore(rowA, wordA, rowB, wordB) {
	return rowA < rowB || (rowA === rowB && wordA < wordB);
}

function createHighlightDivs() {
	for (var image in imageData) {
		loadHighlightForOneImage(image, imageData)
	}
}

// Expose functions to window for Stimulus controllers
if (typeof window !== 'undefined') {
	window.highlightFeature = highlightFeature;
	window.loadHighlightForOneImage = loadHighlightForOneImage;
	window.clickHighlightButton = clickHighlightButton;
	window.attachHighlightEvents = attachHighlightEvents;
	window.detachHighlightEvents = detachHighlightEvents;
	if (typeof highlighter !== 'undefined') {
		window.highlighter = highlighter;
	}
}